import type { Account } from './account.interface';
import type { Image } from './image.interface';
import type { Order } from './order.interface';

export interface User {
  id: number;
  name: string;
  email: string;
  active?: number;
  role_id: number;
  role: Role;
  account_user_role: UserAccountUserRole;
  language_id: number;
  language: Language;
  last_login?: Date;
  created_at: Date;
  updated_at: Date;
  current_account?: Account;
  current_account_id?: number;
  current_order?: Order;
  current_order_id?: number;
  accounts?: Account[];
  avatar?: Image;
  social_meta?: UserSocialMeta;
  social_providers?: UserSocialProvider[];
  has_password?: boolean | null;
}

export type SocialProviderSlug = 'google' | 'tiendanube' | 'mercadolibre';

export interface UserSocialProvider {
  provider: SocialProviderSlug;
  linked: boolean;
}

export interface UserSocialMeta {
  user_id: number;
  access_token: string;
  token_type: string;
  scopes: string;
  business_name: string;
  business_address: string;
  name: string;
  email: string;
  contact_email: string;
  phone: string | null;
  address: string;
  country: number;
  url: string;
  avatar: string;
}

export enum LanguageCode {
  ES = 'es',
  PT = 'pt',
  EN = 'en',
}
export interface Language {
  id: number;
  name: string;
  code: LanguageCode;
}

export enum RoleType {
  SYSTEM = 'SYSTEM',
  ACCOUNT = 'ACCOUNT',
}
export interface Role {
  id: number;
  name: string;
  type: RoleType;
}

export interface UserAccountUserRole {
  id?: number;
  description?: string;
  name?: string;
  role?: RoleType;
}
